import { init as initFullStory } from '@fullstory/browser';
import { init as initDatadogRum } from '@servicetitan/datadog-rum';
import ReactDOM from 'react-dom/client';

import { App } from './app';
import { beforeSend } from './before-send';
import { datadogGuard } from './datadog-guard';
import { isDatadogRumEnabled } from './is-datadog-rum-enabled';

function getEnvironment() {
    const hostname = window.location.hostname;

    if (hostname.includes('customerportal-stage')) {
        return 'stage';
    } else if (hostname.includes('st.dev')) {
        return 'qa';
    } else if (hostname.includes('myservicetitan.com')) {
        return 'production';
    } else if (hostname.includes('next.servicetitan.com')) {
        return 'next';
    }

    return 'development';
}

initFullStory({ orgId: '8HR7J', devMode: process.env.NODE_ENV === 'development' });

initDatadogRum({
    service: { name: 'customer-portal-2' },
    application: {
        applicationId: '7507aba7-695f-427f-9077-c996ab6b7410',
        clientToken: 'pub1cab0c444505f0909517fc31c7892f13',
        site: 'datadoghq.com',
        env: getEnvironment(),
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        defaultPrivacyLevel: 'mask-user-input',
        trackUserInteractions: true,
        trackResources: true,
        trackResourceHeaders: [{ name: 'x-st-correlationid', location: 'response' }],
        excludedActivityUrls: [/fullstory\.com/],
        beforeSend,
    },
    enabled: isDatadogRumEnabled(window.location.hostname),
});

if (isDatadogRumEnabled(window.location.hostname) && window.DD_RUM) {
    datadogGuard(window.DD_RUM);
}

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);
const rootContainer = ReactDOM.createRoot(appContainer);

rootContainer.render(<App />);
